import axios from 'axios';

export default () => {
  const registrationForm = document.querySelector('#event-registration-form');

  if (!registrationForm) {
    return;
  }

  const participantName = registrationForm.querySelector('input[name="name"]'),
        participantEmail = registrationForm.querySelector('input[name="email"]'),
        participantPhone = registrationForm.querySelector('input[name="phone"]'),
        postId = registrationForm.querySelector('input[name="event"]'),
        postTitle = registrationForm.querySelector('input[name="post_title"]'),
        alertSuccess = registrationForm.querySelector('.alert-success'),
        formFields = registrationForm.querySelectorAll(`input`);

  const registerParticipant = async function(e){
    e.preventDefault();
    
    const request = await axios.post('/event-registration', {
      name: participantName.value,
      email: participantEmail.value,
      phone: participantPhone.value,
      event: postId.value,
      post_title: postTitle.value
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).catch(error => {
      if (error.response) {
        formFields.forEach(input => {
          let inputContainer = input.parentNode;
    
          if ( inputContainer && inputContainer.classList.contains('input-error') ) {
            inputContainer.classList.remove('input-error');
          }
        });
        
        const errors = error.response.data[0];

        for(const error in errors){
          const input = registrationForm.querySelector(`input[name="${error}"]`),
                inputErrMessageEl = registrationForm.querySelector(`input[name="${error}"] + .error-message span`);
          input.parentNode.classList.add('input-error');
          inputErrMessageEl.textContent = errors[error];
        }

        return;
      }
    });

    if(request.data.success){
      alertSuccess.classList.remove('d-none');
      alertSuccess.textContent = request.data.success;
    }
  }

  registrationForm?.addEventListener('submit', registerParticipant);
}